import { render, staticRenderFns } from "./V1-0-2.vue?vue&type=template&id=252cb6a6&scoped=true&"
import script from "./V1-0-2.vue?vue&type=script&lang=js&"
export * from "./V1-0-2.vue?vue&type=script&lang=js&"
import style0 from "./V1-0-2.vue?vue&type=style&index=0&id=252cb6a6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252cb6a6",
  null
  
)

export default component.exports